import React from 'react';

const Icon = ({ icon, size = '16px', ...props }) => {
  const Component = icon;
  return (
    <Component {...props} height={size} width={size} />
  );
};

export default Icon;

// Icons
export { default as Add } from './Add';
export { default as Antenna } from './Antenna';
export { default as ArrowRight } from './ArrowRight';
export { default as Attachment } from './Attachment';
export { default as Bell } from './Bell';
export { default as Bold } from './Bold';
export { default as Categories } from './Categories';
export { default as Checkmark } from './Checkmark';
export { default as CheckeredFlag } from './CheckeredFlag.jsx';
export { default as Code } from './Code';
export { default as Copy } from './Copy';
export { default as DragHandle } from './DragHandle';
export { default as EditPencil } from './EditPencil';
export { default as Envelope } from './Envelope';
export { default as Explosion } from './Explosion';
export { default as Eye } from './Eye';
export { default as Fullscreen } from './Fullscreen';
export { default as FullscreenDouble } from './FullscreenDouble';
export { default as Heading } from './Heading';
export { default as Horn } from './Horn';
export { default as Image } from './Image';
export { default as Italic } from './Italic';
export { default as Link } from './Link';
export { default as LongArrowRight } from './LongArrowRight';
export { default as Menu } from './Menu';
export { default as Paperclip } from './Paperclip';
export { default as Password } from './Password';
export { default as Remove } from './Remove';
export { default as Reset } from './Reset';
export { default as RespondArrow } from './RespondArrow';
export { default as Slack } from './Slack';
export { default as SlideArrows } from './SlideArrows';
export { default as SmallWorld } from './SmallWorld';
export { default as Subheading } from './Subheading';
export { default as Team } from './Team';
export { default as Underline } from './Underline';
export { default as Unlink } from './Unlink';
export { default as QuestionMark } from './QuestionMark';
export { default as YoungPlant } from './YoungPlant';
